import { FIELD_TO_PAYLOAD_KEY } from "./constants";
import { FieldToPayloadKey } from "./types";

export const isMappedFieldKey = (k: string): k is FieldToPayloadKey =>
  k in FIELD_TO_PAYLOAD_KEY;
